import * as React from "react";

function SvgProgress(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={2.25}
        y={8.5}
        width={8}
        height={8}
        rx={2}
        transform="rotate(-45 2.25 8.5)"
        fill="#CD4D0B"
      />
    </svg>
  );
}

export default SvgProgress;
